
const Loading = () => {
  return <div id="loading">Loding ...</div>;
};

export default Loading;
